import { render, staticRenderFns } from "./CreatePostGif.vue?vue&type=template&id=2ba5b002&"
import script from "./CreatePostGif.vue?vue&type=script&lang=js&"
export * from "./CreatePostGif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports